import { defineStore } from 'pinia';
import { AutoUserDTO } from '@/dto/user';
import { api } from '@/request/api';

interface UserState {
  user: AutoUserDTO | null;
}

export const useUser = defineStore('user', {
  state: (): UserState => ({
    user: null,
  }),
  actions: {
    async loadUser() {
      const res = await api.loginUserInfo();
      this.user = res.data;
      return this.user;
    },
  },
  getters: {
    getCompanyId(): string | null {
      return this.user?.autoCompanyId || null;
    },
    checkRole: (state) => (role: string) => {
      return state.user?.roles?.includes(role) || false;
    },
    checkPermission: (state) => (permission: string) => {
      return (
        state.user?.permissions?.includes(permission) || state.user?.permissions?.includes('*')
      );
    },
    checkRoutePermission: (state) => (permission: string) => {
      return (
        (state.user?.permissions?.includes(permission) ||
          state.user?.permissions?.includes('*') ||
          false) &&
        state.user?.menus.includes(permission)
      );
    },
    getLoginCorpid(): string | null {
      return this.user?.loginCorpid || null;
    },
  },
});
